import { getEstTimestamp } from '@klv/organisms/countdown/utils/functions';
import type { ITimeRemaining } from '../types';

export const defaultTimer = { days: '00', hours: '00', minutes: '00', seconds: '00' };

export const calculateTimeRemaining = (targetDate: number): ITimeRemaining => {
  const difference = targetDate - getEstTimestamp();

  // set defaults, we want leading 0's
  if (difference <= 0) {
    return defaultTimer;
  }
  // calculate the days hours minutes and seconds.
  const days = Math.floor(difference / 86400000);
  const hours = Math.floor((difference % 86400000) / 3600000);
  const minutes = Math.floor((difference % 3600000) / 60000);
  const seconds = Math.floor((difference % 60000) / 1000);

  // return the countdown object with leading 0's
  return {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};
